import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=1e457841&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=1e457841&scoped=true&lang=scss&"
import style1 from "./newsList.vue?vue&type=style&index=1&id=1e457841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e457841",
  null
  
)

export default component.exports